var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-picker',{attrs:{"mode":_vm.mode,"masks":{ input: ['DD/MM/YYYY'] },"popover":_vm.options.popover,"input-props":{
      class: _vm.getDisplayClass(),
      placeholder: _vm.placeholder,
    }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }